// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TmcColumnDefinition, ITmcColumnDefinition } from "./Reports.TmcColumnDefinition.gen";
import { TurningMovementCountV2, ITurningMovementCountV2 } from "./Reports.TurningMovementCountV2.gen";

export interface ITurningMovementCountReportV2 {
	deviceIds: string[] | undefined;

	startDate: string | undefined;

	endDate: string | undefined;

	columns: ITmcColumnDefinition[] | undefined;

	counts: ITurningMovementCountV2[] | undefined;

	$type?: string | undefined;
}
export class TurningMovementCountReportV2 {
	constructor(data?: ITurningMovementCountReportV2) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.startDate) { this.startDate = new Date(data.startDate); }
		if (data.endDate) { this.endDate = new Date(data.endDate); }
		this.columns = data.columns ? data.columns.map((c: any) => new TmcColumnDefinition(c)) : [];
		this.counts = data.counts ? data.counts.map((c: any) => new TurningMovementCountV2(c)) : [];
	}

	deviceIds: string[] | undefined;

	startDate: Date | undefined = new Date();

	endDate: Date | undefined = new Date();

	columns: TmcColumnDefinition[] | undefined = [];

	counts: TurningMovementCountV2[] | undefined = [];

	static $type: string = "CoreApi.Models.Reports.TurningMovementCountReportV2, ";
	$type?: string | undefined = TurningMovementCountReportV2.$type;
}

